// MOBILE-PARITY 2026-07-04 (QJ addendum): the expanding magnifier-toggle search input
// (`!w-0`/`!w-full` important-utility conflict left it permanently zero-width -- invisible)
// is removed entirely. Search now lives as an ALWAYS-VISIBLE input in the sort/filter row
// (see ../../Filters/index.tsx). This component is reduced to just the "Inbox" title line
// it also used to render -- title behavior unchanged.
const Search = () => {
  return (
    <div className="flex h-8 w-full items-center justify-between md:px-4">
      <div className="text-xl font-medium text-[#161A22]">Inbox</div>
    </div>
  )
}

export default Search
